document.addEventListener("DOMContentLoaded", function () {
  const allBundles = document.querySelectorAll(".bundle-subscription-container");

  allBundles.forEach((bundle) => {
    const radios = bundle.querySelectorAll(
      'input[type="radio"][name^="bundle-purchase-option"]'
    );
    const frequencyWrapper = bundle.querySelector(".js-subscription-frequency");
    const select = bundle.querySelector("select[name='selling_plan']");
    const atcPriceSpan = bundle.closest("form")?.querySelector(".product-grid-item-atc-price");

    const oneTimePriceEl = bundle.querySelector(".one-time-price");
    const subscriptionPriceEl = bundle.querySelector(".subscription-price");

    const originalPrice = oneTimePriceEl?.getAttribute("data-price");
    const discountedPrice = subscriptionPriceEl?.getAttribute("data-price");

    radios.forEach((radio) => {
      radio.addEventListener("change", function () {
        if (this.value === "subscribe") {
          frequencyWrapper?.classList.remove("hidden");
          select?.removeAttribute("disabled");
          const actualPrice = bundle.querySelector(".actual-price")?.getAttribute("data-actual-price");;
          if (actualPrice) {
             atcPriceSpan.innerHTML = `<s class="subscription-price">${actualPrice}</s> ${discountedPrice}`;
             bundle.nextElementSibling.querySelector(".matafiled-price")?.classList.add("hidden");
          }else{
            if (atcPriceSpan && discountedPrice && originalPrice) {
              atcPriceSpan.innerHTML = `<s class="subscription-price">${originalPrice}</s> ${discountedPrice}`;
              bundle.nextElementSibling.querySelector(".matafiled-price")?.classList.add("hidden");
            }
          }
        } else {
          frequencyWrapper?.classList.add("hidden");
          select?.setAttribute("disabled", "disabled");

          const actualPrice = bundle.querySelector(".actual-price")?.getAttribute("data-actual-price");;
          if (actualPrice) {
             atcPriceSpan.innerHTML = `<s class="subscription-price">${actualPrice}</s> ${originalPrice}`;
             bundle.nextElementSibling.querySelector(".matafiled-price")?.classList.add("hidden");
          }else{
            if (atcPriceSpan && originalPrice) {
              atcPriceSpan.textContent = originalPrice;
            }
          }
        }
      });
    });

    // Set initial state
    const checkedRadio = bundle.querySelector('input[type="radio"]:checked');
    if (checkedRadio?.value === "subscribe") {
      frequencyWrapper?.classList.remove("hidden");
      select?.removeAttribute("disabled");

      if (atcPriceSpan && discountedPrice && originalPrice) {
        atcPriceSpan.innerHTML = `<s>${originalPrice}</s> ${discountedPrice}`;
      }
    } else {
      select?.setAttribute("disabled", "disabled");
      console.log(originalPrice,88);
      
      if (atcPriceSpan && originalPrice) {
        // atcPriceSpan.textContent = originalPrice;
      }
    }
  });
});
